<template>
  <section class="notData" :style="boxStyle">
    <img src="@/assets/image/notData.png" alt="暂无数据">
    <span>暂无数据</span>
  </section>
</template>

<script>
export default {
  name: 'NotData',
  props: {
    top: {
      type: [Number, String],
      default: 100
    }
  },
  computed: {
    boxStyle() {
      return {
        marginTop: this.top + 'px'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.notData {
  margin-bottom: 0;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    width: 209px;
    margin-bottom: 20px;
  }
  span {
    font-size: 14px;
    font-weight: 400;
    color: $grey-font-color;
    line-height: 20px;
  }
}
</style>